module.exports = __webpack_public_path__ + "static/media/home_bg2.2e8f6105.webp";